export default function updatePageNumberQueryParamSearchList(
  pageNumber,
  query
) {
  /* new page is zero indexed but to make our page more SEO friendly we'll change
    it here from 0 to go to 2 instead of 1. That way we avoid changing it everywhere
    because the Search API uses zero indexed pages */
  const searchParams = new URLSearchParams(location.search);
  searchParams.set("page", pageNumber);

  pageNumber === 1 && searchParams.delete("page");
  history.pushState(
    { page: pageNumber, query: query },
    document.title,
    `?${searchParams.toString()}`
  );
}
